import { z } from "zod";

/** Describes verified days in the requested reporting interval. */
export const reportCoverageSchema = z.object({
  status: z.enum(["complete", "partial", "unknown"]),
  coveredDays: z.number().int().nonnegative(),
  expectedDays: z.number().int().nonnegative(),
  reason: z.enum(["unsupported_ad_types", "unknown_timezone"]).optional(),
  period: z
    .object({
      selected: z.object({
        startDate: z.string().date(),
        endDate: z.string().date(),
        days: z.number().int().nonnegative(),
      }),
      reportable: z
        .object({
          startDate: z.string().date(),
          endDate: z.string().date(),
          days: z.number().int().nonnegative(),
        })
        .nullable(),
      pendingDays: z.number().int().nonnegative().nullable(),
      comparison: z
        .object({
          startDate: z.string().date(),
          endDate: z.string().date(),
          days: z.number().int().nonnegative(),
        })
        .nullable(),
      comparisonComplete: z.boolean(),
    })
    .optional(),
});
export type ReportCoverage = z.infer<typeof reportCoverageSchema>;
